import { render } from "./LeaveAdminLegalDocumentFormView.vue?vue&type=template&id=36544d19&scoped=true"
import script from "./LeaveAdminLegalDocumentFormView.vue?vue&type=script&lang=js"
export * from "./LeaveAdminLegalDocumentFormView.vue?vue&type=script&lang=js"

import "./LeaveAdminLegalDocumentFormView.vue?vue&type=style&index=0&id=36544d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36544d19"]])

export default __exports__